import axios from 'axios'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    partiesQueryParams: {},
    profile: {},
    projects: [],
    // Empresas de un usuario
    partiesUser: {
      tableData: [],
      totalPartiesUser: 0
    }
  }
  return session
}
// state
const state = {
  local: {},
  session: initSession()
}

// getters
const getters = {
  getMyPartiesQueryParams: state => {
    return state.session.partiesQueryParams
  },
  profile: state => {
    return state.session.profile
  },
  projects: state => {
    return state.session.projects
  },
  partiesUser: state => {
    return state.session.partiesUser
  }
}

// actions
const actions = {
  isNewVersionProfileLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.profile)
  },
  selectPartiesUser ({ commit }, partiesUser) {
    return new Promise((resolve) => {
      commit('SELECTED_PARTIES_USER', partiesUser)
      resolve()
    })
  },  
  async modifyPassword ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/me/password',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {password: {
          newPassword: btoa(params.password.newPassword),
          oldPassword: btoa(params.password.oldPassword),
          repeatNewPassword: btoa(params.password.repeatNewPassword)
        }
      }
      })
      console.log('RESPONSE modifyPassword:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.error('ERROR modifyPassword:: ', error)
      throw error.response
    }
  },

  async updateMe ({
    commit, state
  }, me) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/me',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: me
      })

      console.log('RESPONSE updateMe:: ', response)

      commit('USER_PROFILE', response.data)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.error('updateMe ERROR --- ', error.response)
      throw error.response
    }
  },

  async getUserParties ({
    commit, rootState
  }, queryparams) {
    try {
      queryparams.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        queryparams.urlName = rootState.session.urlIn
      }
      commit('PROFILE_PARTIES_QUERYPARAMS', queryparams)
      const response = await axios({
        method: 'GET',
        url: '/me/party',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: queryparams
      })
      console.log('RESPONSE getUserParties:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.error('ERROR --- ', error.response)
      throw error.response ? error.response : error
    }
  },

  async getUserPartiesSignature ({
    commit, rootState
  }, request) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me/party/AllParties',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,        
        params: request
      })
      console.log('RESPONSE getUserPartiesSignature:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.error('ERROR --- ', error.response)
      throw error.response ? error.response : error
    }
  },

  async validarDNI ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me/party/Signature/validateDNI',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          dni: params.dni
        }
      })
      console.log('RESPONSE validarDNI:: ', params)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.error('ERROR --- ', error.response)
      throw error.response ? error.response : error
    }
  },

  async getUserPartiesSignaturePDF ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me/party/Signature/PDF',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,        
        params: {
          taxIdentificationNumber: params.taxIdentificationNumber,
          corporateName: params.corporateName,
          address: params.address,
          town: params.town,
          postcode: params.postcode,
          province: params.province,
          countryName: params.countryName,
          nombre: params.nombre,
          apellido1: params.apellido1,
          apellido2: params.apellido2,
          dni: params.dni,
          cargoFirmante: params.cargoFirmante,
          poblacionFirma: params.poblacionFirma,
          resolucion: params.resolucion,
          fecha: params.fecha,
          fechaDD: params.fechaDD,
          fechaMM: params.fechaMM,
          fechaAAAA: params.fechaAAAA
        },
        responseType: 'blob'
      })
      console.log('RESPONSE getUserPartiesSignature:: ', params)
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'DelegacionFirma.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.error('ERROR --- ', error.response)
      throw error.response ? error.response : error
    }
  },

  // Datos de PartyMedia
  async getPartyUserMedia ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/party/' + params.partyId + '/partymedia/',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      console.log('RESPONSE getPartyMedia:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async getUserPartiesCsv ({
    commit, rootState
  }, queryparams) {
    try {
      queryparams.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        queryparams.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/me/party/csv',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: queryparams,
        headers: { 'Accept-Language': queryparams.activeLang },
        responseType: 'blob'
      })
      console.log('RESPONSE getUserPartiesCsv:: ', response)
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'empresausuario.csv'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.error('getUserPartiesCsv :: ERROR --- ', error)
      throw error.response ? error.response : error
    }
  },

  async getMyUserMedia ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me/usermedia',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL        
      })
      console.log('RESPONSE getMyUserMedia:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.error('ERROR --- ', error.response)
      throw error.response ? error.response : error
    }
  },

  async addMyUserMedia ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/me/usermedia',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })
      console.log('RESPONSE addMyUserMedia:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.error('ERROR --- ', error.response)
      throw error.response ? error.response : error
    }
  },

  async deleteAllUserMedia ({
    commit, rootState
  }, userMediaId) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/me/usermedia/deleteAll',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      console.log('RESPONSE deleteAllUserMedia:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.error('ERROR --- ', error.response)
      throw error.response ? error.response : error
    }
  },
  async getProfile ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL        
      })
      commit('USER_PROFILE', response.data)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getUserProjectsList ({
    commit, rootState
  }) {
    return new Promise(async (resolve, reject) => { // eslint-disable-line
      const params = {
        size: 1000,
        page: 0
      }
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      let projects = []
      let isLastPage = false
      do {
        projects = await axios({
          method: 'GET',
          url: '/me/project',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          params: params
        })
          .then(response => {
            fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
            isLastPage = response.data.last
            return response.data.content
          })
          .catch(error => {
            console.log('ERROR --- ', error.response)
            isLastPage = true
            return []
          })
        params.size = params.size * 2
      } while (!isLastPage)
      resolve(projects)
      commit('USER_PROJECTS_LOADED', projects)
    })
  },  

  profileState: ({
    commit
  }, payload) => {
    commit('USER_PROFILE', payload)
  }
}

// mutations
const mutations = {
  resetSessionProfile (state) {
    state.session = initSession()
  },
  'PROFILE_PARTIES_QUERYPARAMS' (state, payload) {
    state.session.partiesQueryParams = payload
  },
  'USER_PROFILE' (state, payload) {
    state.session.profile = payload
  },
  'USER_PROJECTS_LOADED' (state, projects) {
    state.session.projects = projects
  },
  'SELECTED_PARTIES_USER' (state, partiesUser) {
    state.session.partiesUser = partiesUser
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
